// Full-document render of the stearns GenericPage: PageSkeleton (the React
// document shell) wrapping the existing generic-page body island (which
// reproduces the per-block block-{type} wrappers). The legacy template rendered
// the body inside <main> with the site header/footer intact, so the document
// DOM matches the other toolbox-body pages.
import React from "react";

import { templates } from "@reactivated";

import { GenericPageBody } from "../components/GenericPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed with
// mutable reactivated props. The body template accepts Immutable props, to which
// these are assignable.
export const Template = (
    props: templates.GenericPageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <GenericPageBody page={props.page} />
    </PageSkeleton>
);
